// src/stores/loading.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGlobalLoadingStore = defineStore('globalLoading', () => {
  const pending = ref(0)      // jumlah proses aktif
  const visible = ref(false)  // tampil/hidden overlay

  let showTimer = null
  let hideTimer = null

  function start(opts = {}) {
    pending.value++
    const delay = opts.delayMs ?? 120

    // kalau ada rencana hide, batalkan (kita mau tampil lagi)
    clearTimeout(hideTimer)

    if (opts.immediate) {
      clearTimeout(showTimer)
      visible.value = true
      return
    }

    clearTimeout(showTimer)
    showTimer = setTimeout(() => {
      if (pending.value > 0) visible.value = true
    }, delay)
  }

  function stop() {
    if (pending.value > 0) pending.value--

    if (pending.value === 0) {
      // tidak perlu show lagi kalau sudah mau hide
      clearTimeout(showTimer)
      clearTimeout(hideTimer)
      hideTimer = setTimeout(() => {
        visible.value = false
      }, 120)
    }
  }

  function reset() {
    pending.value = 0
    visible.value = false
    clearTimeout(showTimer)
    clearTimeout(hideTimer)
  }

  // Menggunakan ref-count, jadi tidak mengganggu operasi lain yang juga menyalakan loader.
  function flash(ms = 1500) {
    start({ immediate: true })
    const t = setTimeout(() => {
      stop()
    }, Math.max(0, ms))
    // return fungsi pembatalan (opsional dipakai kalau perlu)
    return () => { clearTimeout(t); stop() }
  }

  async function withLoader(promise, opts = {}) {
    try {
      start(opts)
      return await promise
    } finally {
      stop()
    }
  }

  return { pending, visible, start, stop, reset, flash, withLoader }
})
